export default {
  VIEW_LANDING_PAGE_CONTENTS: "LandingPageContents",
};
